// this file added by Bearer Web Developer
import { Button } from "@mui/material";
import React from "react";
import styles from './FreeDelivery.module.scss';
import { useAppState } from "../../../states/app-state";
import { useThemeMode } from "../../../states/contexts/theme";

const FreeDelivery: React.FC = () => {

    const appState = useAppState();
    const { accountVerification, createAccount, completeProfile } = appState;
    const handleClose = () => {
        if (createAccount?.complete_registeration) completeProfile?.setOpen(true);
        accountVerification?.setOpen(false);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.free_delivery} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.header}>
                <h5>Enjoy a FREE Delivery!</h5>
                <div><Button onClick={handleClose}><img src="/cancel.png" alt="X" /></Button></div>
            </div>
            <p>
                A <span>FREE</span> delivery has been automatically applied to your account. Just place an order and save instantly!
            </p>
            <div className={styles.cover}>
                <img src="/free-order-cover.webp" alt="" width={254} />
            </div>
            <div className={''}>
                <Button className={styles.submit} onClick={handleClose}>OK</Button>
            </div>
        </div>
    )
}
export default FreeDelivery;